import { get, isNil, uniqueId } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Siema from 'siema';

import Theme from 'styles/theme';

import Dots from './Dots';

export { Dots };

const Carousel = class extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    onChange: PropTypes.func,
    onInit: PropTypes.func,
    options: PropTypes.shape({}),
    currentSlide: PropTypes.number,
  };

  static defaultProps = {
    children: null,
    onChange: () => {},
    onInit: () => {},
    options: {},
    currentSlide: null,
  };

  static get defaultOptions() {
    return {
      duration: 200,
      easing: Theme.get('transition-timing-ease-out'),
      perPage: 1,
      startIndex: 0,
      draggable: true,
      multipleDrag: true,
      threshold: 20,
      loop: true,
      rtl: false,
    };
  }

  constructor(props) {
    super(props);
    this.id = uniqueId(`allbirds-carousel-`);
  }

  componentDidMount() {
    // https://pawelgrzybek.github.io/siema/#options
    this.siema = new Siema({
      ...this.options,
      startIndex: this.props.currentSlide || this.options.startIndex,
      onInit: this.handleInit,
      onChange: this.handleChange,
      selector: `#${this.id}`,
    });

    // Force change handler to run
    this.handleChange();
  }

  componentDidUpdate() {
    const { currentSlide } = this.props;

    if (!isNil(currentSlide) && currentSlide !== this.currentSlide) {
      this.siema.goTo(currentSlide);
    }
  }

  componentWillUnmount() {
    this.siema?.destroy(true);
  }

  get options() {
    return {
      // default options
      ...Carousel.defaultOptions,
      // option overrides
      ...this.props.options,
    };
  }

  get currentSlide() {
    return get(this.siema, 'currentSlide');
  }

  handleInit = () => {
    this.props.onInit();
  };

  handleChange = () => {
    this.props.onChange(this.currentSlide);
  };

  render() {
    const { children } = this.props;

    return (
      <div id={this.id} className="Carousel">
        {children}
      </div>
    );
  }
};

export default Carousel;
